var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"auth-submit",class:['auth-submit--' + _vm.variant, { 'is-disabled': _vm.isInactive }],attrs:{"type":"button","disabled":_vm.isInactive},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('span',{staticClass:"auth-submit__spinner"}):_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-296af674","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/auth/AuthSubmitButton.vue
// module id = null
// module chunks = 